var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',{staticClass:"left-section"},[_c('div',{staticClass:"pt-5 d-flex flex-column",staticStyle:{"width":"320px"}},[_c('company-info-card',{staticClass:"mb-5",attrs:{"profile":_vm.profile}})],1)])
}
var staticRenderFns = []

export { render, staticRenderFns }